<!--
 * @Description: 平台账户中心（平台子账户）
-->
<template>
  <scroll-layout>
    <div class="platform-account-center">
      <!-- 账户余额 / 结算银行卡 -->
      <div class="top-card-wrap">
        <div class="top-card balance-card">
          <div class="card-title">账户余额（元）</div>
          <div class="card-value">{{ accountInfo.settlementBalance | formatAmount }}</div>
          <div class="card-sub">
            <span>含可提现金额：</span>
            <span class="card-sub-value">{{ accountInfo.withdrawBalance | formatAmount }}</span>
          </div>
          <ykc-button class="settle-btn" @click="handleGoSettle">提现</ykc-button>
        </div>
        <div class="top-card bank-card">
          <div class="card-title">
            <span>结算银行卡</span>
            <div class="card-title-actions">
              <span
                v-if="bankCardInfo.isActived === 0"
                class="action-text active"
                @click="handleActivateBankCard">
                立即激活
              </span>
            </div>
          </div>
          <div class="card-value">{{ bankCardInfo.bankNo | formatCardNo }}</div>
          <div class="card-sub">
            <span>银行名称：{{ bankCardInfo.bankName || '-' }}</span>
          </div>
        </div>
      </div>

      <!-- 账户流水记录 -->
      <div class="flow-record-section">
        <div class="section-title">账户流水记录</div>
        <ykc-search
          ref="YkcSearch"
          :data="searchData"
          :searchForm="searchParams"
          @click="handleSearchConfirm"
          @clean="handleSearchClean"></ykc-search>
        <div class="export-wrap">
          <ykc-button type="plain" @click="doExportFile">导出</ykc-button>
        </div>
        <ykc-table ref="YkcTable" :data="tableData" :columns="tableColumns">
          <ykc-pagination
            slot="pagination"
            ref="YkcPagination"
            direct="flex-end"
            :total="pageInfo.total"
            :current-page.sync="pageInfo.pageIndex"
            @current-change="handlePaginationCurrentChange"
            :page-size.sync="pageInfo.pageSize"
            @size-change="handlePaginationSizeChange"></ykc-pagination>
        </ykc-table>
      </div>
    </div>

    <!-- 平台结算 -->
    <ykc-operation-dialog
      title="提现"
      confirm-btn-txt="确认提现"
      :before-confirm="handleConfirmSettle"
      :confirm-loading="settleSubmitting"
      :show.sync="settleDialogVisible">
      <div slot="content">
        <div class="settle-balance-wrap">
          可提现金额：
          <span class="settle-balance">{{ accountInfo.withdrawBalance | formatAmount }}元</span>
        </div>
        <ykc-form ref="settleForm" :model="settleForm" :rules="settleRules">
          <ykc-form-item label="提现金额" prop="settleAmount">
            <ykc-input
              v-model="settleForm.settleAmount"
              placeholder="请输入"
              maxlength="12"></ykc-input>
          </ykc-form-item>
        </ykc-form>
        <div class="settle-tip">注意：请谨慎提现，确保有充足金额用于分账！</div>
      </div>
    </ykc-operation-dialog>
  </scroll-layout>
</template>

<script>
  import YkcOperationDialog from '@/components/ykc-ui/operation-dialog';
  import { platformAccountCenter } from '@/service/apis';
  import { offlineExport } from '@/utils';

  export default {
    name: 'PlatformAccountCenter',
    components: {
      YkcOperationDialog,
    },
    data() {
      return {
        accountInfo: {},
        bankCardInfo: {},
        settleDialogVisible: false,
        settleSubmitting: false,
        settleForm: {
          settleAmount: '',
        },
        settleRules: {
          settleAmount: [{ required: true, message: '请输入结算金额', trigger: 'blur' }],
        },
        tableData: [],
        pageInfo: {
          total: 0,
          pageIndex: 1,
          pageSize: 10,
        },
        searchParams: {
          flowNo: '',
          flowType: '',
          flowDirection: '',
          flowObject: '',
          flowObjectAccount: '',
          flowDate: [],
        },
        flowTypeOptions: [
          { id: 1, name: '清分' },
          { id: 2, name: '分账' },
          { id: 3, name: '分账退回' },
          { id: 4, name: '提现' },
        ],
        flowDirectionOptions: [
          { id: 1, name: '收入' },
          { id: 0, name: '支出' },
        ],
        // 与后端 FlowObjectEnum 对应：1平台子账户 2银行卡 3备付金账户 4商户账号 5银行卡账号
        flowObjectOptions: [
          { id: 1, name: '平台子账户' },
          { id: 2, name: '银行卡' },
          { id: 3, name: '备付金账户' },
          { id: 4, name: '商户账号' },
          { id: 5, name: '银行卡账号' },
        ],
        tableColumns: [
          {
            label: '流水号',
            prop: 'flowNo',
            minWidth: '160px',
            scopedSlots: {
              default: ({ row }) => this.renderFlowNoCell(row.flowNo),
            },
          },
          { label: '流水时间', prop: 'flowTime', minWidth: '160px' },
          { label: '流水金额（元）', prop: 'flowAmount', minWidth: '120px' },
          { label: '流水类型', prop: 'flowTypeStr', minWidth: '100px' },
          { label: '收支方向', prop: 'flowDirectionStr', minWidth: '100px' },
          { label: '流水对象', prop: 'flowObjectStr', minWidth: '120px' },
          { label: '流水对象账户号', prop: 'flowObjectAccount', minWidth: '200px' },
        ],
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcInput',
            key: 'flowNo',
            label: '流水号',
            placeholder: '请输入流水号',
          },
          {
            comName: 'YkcDropdown',
            key: 'flowType',
            data: this.flowTypeOptions,
            label: '流水类型',
            placeholder: '请选择流水类型',
          },
          {
            comName: 'YkcDropdown',
            key: 'flowDirection',
            data: this.flowDirectionOptions,
            label: '收支方向',
            placeholder: '请选择收支方向',
          },
          {
            comName: 'YkcDropdown',
            key: 'flowObject',
            data: this.flowObjectOptions,
            label: '流水对象',
            placeholder: '请选择流水对象',
          },
          {
            comName: 'YkcInput',
            key: 'flowObjectAccount',
            label: '流水对象账户号',
            placeholder: '请输入流水对象账户号',
          },
          {
            comName: 'YkcDatePicker',
            key: 'flowDate',
            label: '流水时间',
            type: 'daterange',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期',
          },
        ];
      },
    },
    filters: {
      formatAmount(val) {
        if (val === undefined || val === null || val === '') return '0.00';
        return Number(val).toFixed(2);
      },
      formatCardNo(val) {
        if (!val) return '-';
        return String(val).replace(/(\d{4})(?=\d)/g, '$1 ');
      },
    },
    created() {
      this.queryAccountInfo();
      this.searchTableList();
    },
    methods: {
      /** 渲染流水号单元格（鼠标悬停显示复制按钮） */
      renderFlowNoCell(flowNo) {
        if (!flowNo) return '——';
        return (
          <span class="flow-no-cell">
            <span class="flow-no-text" title={flowNo}>
              {flowNo}
            </span>
            <i
              class="el-icon-document-copy flow-no-copy-btn"
              title="复制"
              onClick={event => {
                event.stopPropagation();
                this.handleCopyFlowNo(flowNo);
              }}></i>
          </span>
        );
      },
      /** 复制流水号 */
      handleCopyFlowNo(flowNo) {
        this.$copyText(flowNo)
          .then(() => {
            this.$message.success('复制成功');
          })
          .catch(() => {
            this.$message.error('复制失败');
          });
      },
      /** 查询平台账户信息（余额 + 绑定银行卡） */
      queryAccountInfo() {
        platformAccountCenter.getAccountInfo().then(res => {
          const data = res || {};
          this.accountInfo = {
            accountBalance: data.accountBalance,
            availableBalance: data.availableBalance,
            settlementBalance: data.settlementBalance,
            withdrawBalance: data.withdrawBalance,
          };
          this.bankCardInfo = {
            openNo: data.openNo,
            bankNo: data.bankNo,
            bankName: data.bankName,
            isActived: data.isActived,
          };
        });
      },
      /** 查询流水列表 */
      searchTableList() {
        const params = {
          flowNo: this.searchParams.flowNo,
          flowType: this.searchParams.flowType,
          flowDirection: this.searchParams.flowDirection,
          flowObject: this.searchParams.flowObject,
          flowObjectAccount: this.searchParams.flowObjectAccount,
          flowTimeStart: (this.searchParams.flowDate && this.searchParams.flowDate[0]) || '',
          flowTimeEnd: (this.searchParams.flowDate && this.searchParams.flowDate[1]) || '',
          current: this.pageInfo.pageIndex,
          size: this.pageInfo.pageSize,
        };
        platformAccountCenter.flowList(params).then(response => {
          this.tableData = (response && response.records) || [];
          this.pageInfo.total = (response && response.total) || 0;
        });
      },
      /** 确认查询 */
      handleSearchConfirm(form) {
        this.pageInfo.pageIndex = 1;
        Object.assign(this.searchParams, form);
        this.searchTableList();
      },
      /** 清空查询 */
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
      },
      /** 分页切换 */
      handlePaginationCurrentChange(current) {
        this.pageInfo.pageIndex = current;
        this.searchTableList();
      },
      /** 分页大小切换 */
      handlePaginationSizeChange(size) {
        this.pageInfo.pageIndex = 1;
        this.pageInfo.pageSize = size;
        this.searchTableList();
      },
      /** 导出该账户下全量流水表 */
      doExportFile() {
        offlineExport(
          {
            downloadType: 'finance_export',
            jsonNode: {
              downloadKey: 'platformFlowRecordExport',
              flowNo: this.searchParams.flowNo,
              flowType: this.searchParams.flowType,
              flowDirection: this.searchParams.flowDirection,
              flowObject: this.searchParams.flowObject,
              flowObjectAccount: this.searchParams.flowObjectAccount,
              flowTimeStart: (this.searchParams.flowDate && this.searchParams.flowDate[0]) || '',
              flowTimeEnd: (this.searchParams.flowDate && this.searchParams.flowDate[1]) || '',
            },
          },
          this.pageInfo.total
        );
      },
      /** 结算弹窗 */
      handleGoSettle() {
        this.settleForm.settleAmount = '';
        this.settleDialogVisible = true;
      },
      /** 确认结算（对收钱吧发起提现，结算至平台绑定的银行实体账户） */
      handleConfirmSettle(hide) {
        this.$refs.settleForm.validate(valid => {
          if (!valid) return;
          const amountStr = this.settleForm.settleAmount.trim();
          if (!/^\d+(\.\d{1,2})?$/.test(amountStr)) {
            this.$message.warning('请输入正确的结算金额（最多两位小数）');
            return;
          }
          const amount = Number(amountStr);
          if (amount <= 0) {
            this.$message.warning('结算金额必须大于0');
            return;
          }
          const balance = Number(this.accountInfo.withdrawBalance || 0);
          if (amount > balance) {
            this.$message.warning('提现金额不能大于可提现金额');
            return;
          }
          this.settleSubmitting = true;
          platformAccountCenter
            .platformSettle({ settleAmount: amount })
            .then(() => {
              this.$message.success('结算申请已提交');
              hide();
              this.queryAccountInfo();
              this.pageInfo.pageIndex = 1;
              this.searchTableList();
            })
            .finally(() => {
              this.settleSubmitting = false;
            });
        });
      },
      /** 立即激活银行卡 */
      handleActivateBankCard() {
        platformAccountCenter.activePlatformBank().then(res => {
          if (res) {
            this.$message.info('立即激活成功');
            this.queryAccountInfo();
          } else {
            this.$message.info('立即激活失败');
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .platform-account-center {
    padding: 20px;

    .top-card-wrap {
      display: flex;
      gap: 20px;
      margin-bottom: 20px;

      .top-card {
        flex: 1;
        padding: 24px;
        background: #fff;
        border: 1px solid #ebeef5;
        border-radius: 4px;

        .card-title {
          font-size: 16px;
          font-weight: 600;
          color: #303133;
          margin-bottom: 12px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .card-title-actions {
            display: flex;
            gap: 16px;

            .action-text {
              font-size: 14px;
              font-weight: normal;
              color: #1890ff;
              cursor: pointer;

              &:hover {
                color: #40a9ff;
              }

              &.active {
                color: #ff9900;

                &:hover {
                  color: #ffad33;
                }
              }
            }
          }
        }

        .card-value {
          font-size: 32px;
          font-weight: 700;
          color: #ff9900;
          margin-bottom: 12px;
          word-break: break-all;
        }

        .card-sub {
          font-size: 14px;
          color: #ff9900;
          margin-bottom: 12px;

          .card-sub-value {
            font-weight: 600;
          }
        }

        .settle-btn {
          min-width: 80px;
        }
      }
    }

    .flow-record-section {
      background: #fff;
      border: 1px solid #ebeef5;
      border-radius: 4px;
      padding: 20px;

      .section-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 16px;
      }

      .export-wrap {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 12px;
      }

      // 流水号单元格：鼠标悬停显示复制按钮
      .flow-no-cell {
        display: inline-flex;
        align-items: center;
        max-width: 100%;

        .flow-no-text {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .flow-no-copy-btn {
          flex-shrink: 0;
          margin-left: 4px;
          color: #1890ff;
          cursor: pointer;
          visibility: hidden;

          &:hover {
            color: #40a9ff;
          }
        }

        &:hover .flow-no-copy-btn {
          visibility: visible;
        }
      }
    }
  }

  .settle-balance-wrap {
    font-size: 14px;
    color: #606266;
    margin-bottom: 16px;

    .settle-balance {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
    }
  }

  .settle-tip {
    font-size: 14px;
    color: #f56c6c;
  }
</style>
